import { NgModule } from '@angular/core';
import { DictionarySearchRequestService } from "./dictionary-search-request.service";
import { ApiResourceModule } from "libraries/service/apiResource/apiResource.module";
import { DictionarySearchResourceService } from "libraries/service/resources/dictionary-search/dictionary-search-resource.service";


@NgModule({
    imports: [
        ApiResourceModule,
    ],

    providers: [
        DictionarySearchRequestService,
        DictionarySearchResourceService
    ],
})
export class DictionarySearchResourceModule {
}
